// For details, see this thread
// https://forum.vuejs.org/t/update-v-model-with-async-prop/28608
export default {
  computed: {
    state: {
      get() {
        return this.value;
      },
      set(newState) {
        this.$emit('input', newState);
      }
    }
  }
};
